<template>
    <div class="Dropdown">
        <div class="Dropdown__button">
            <slot
                :open="open"
                :isModal="isModal"
                :toggleDropdown="toggleDropdown"
                :setDropdown="setDropdown"
                :closeDropdown="closeDropdown"
                :disabled="disable"
            ></slot>
        </div>

        <div
            v-if="!isModal && showDropdown"
            :class="[
                'Dropdown__dropdown',
                `Dropdown__dropdown--${dropdownPosition}`
            ]"
        >
            <slot
                name="dropdown"
                :close="closeDropdown"
            ></slot>
        </div>
        <RPModal
            v-if="isModal && showDropdown"
            :show-action-buttons="false"
            :header="modalHeader"
            @close-modal="closeDropdown"
        >
            <template slot="modalBody">
                <slot
                    name="dropdown"
                    :isModal="true"
                    :close="closeDropdown"
                ></slot>
            </template>
        </RPModal>
    </div>
</template>
<script>
import RPModal from 'components/Complex/Modal/RPModal.vue';
import stat from 'status/index';

export default {
    name: "Dropdown",
    components: {
        RPModal,
    },
    props: {
        dropdownPosition: {
            type: String,
            default: 'right',
            validator: val => ['left', 'right', 'center'].indexOf(val) !== -1
        },
        modalBreakpoint: {
            type: Number,
            default: 320,
        },
        modalHeader: {
            type: String,
            default: 'Select an option...'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        status: {
            type: String,
            default: stat.STANDBY
        }
    },
    data() {
        return {
            open: false,
            size: 1000
        };
    },
    computed: {
        isModal() {
            return this.size < this.modalBreakpoint;
        },
        disable(){
            return this.disabled || this.status === stat.LOADING;
        },
        showDropdown(){
            return !this.disable && this.open;
        },
    },
    destroyed(){
        document.removeEventListener('click', this.close);
        document.removeEventListener('resize', this.resize);
    },
    mounted() {
        document.addEventListener('click', this.close);
        window.addEventListener('resize', this.resize);
        this.resize();
    },
    methods: {
        resize(){
            this.size = Math.min(window.innerWidth, window.screen.width);
        },
        toggleDropdown(){
            this.open = !this.open;
        },
        setDropdown(bool){
            this.open = bool;
        },
        closeDropdown(){
            this.open = false;
        },
        close(e){
            if(!this.$el.contains(e.target)){
                this.open = false;
            }
        }
    }
};
</script>

<style lang="scss">
.Dropdown {
    display: inline-block;
    white-space: nowrap;
    position: relative;
    cursor: pointer;
    &__button {
        position: relative;
        display: contents;
    }
    &__dropdown {
        min-width: 100%;
        position:absolute;
        z-index: 99;

        &--right { right: 0; }
        &--left { left: 0; }
        &--center {
            left: 50%;
            transform: translateX(-50%);
        }
    }
}
</style>